import React from 'react';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HomeHero } from '../components/home/HomeHero';
import { CompatibilityStrip } from '../components/home/CompatibilityStrip';
import { Benefits } from '../components/home/Benefits';
import { SalderingBand } from '../components/home/SalderingBand';
import { ScanTeaser } from '../components/home/ScanTeaser';
import { AppSection } from '../components/home/AppSection';
import { ProductExplorer } from '../components/home/ProductExplorer';
import { ProcessTimeline } from '../components/home/ProcessTimeline';
import { Reviews } from '../components/home/Reviews';
import { Faq } from '../components/home/Faq';
import { FinalCta } from '../components/home/FinalCta';
import { useHashScroll } from '../hooks/useHashScroll';
export function Home() {
  useHashScroll();
  return <div className="min-h-screen w-full bg-canvas" data-id="element-741" data-mp="3ov2h8pai3zw5">
      <AnnouncementBar data-id="element-742" data-mp="30x1hubsnqiox" />
      <Header overlay data-id="element-743" data-mp="30vgp8rpwl9tp" />
      <main data-id="element-744" data-mp="30up1g32jsgdz">
        <HomeHero data-id="element-745" data-mp="30ufaac5ro36p" />
        <CompatibilityStrip data-id="element-746" data-mp="2vxydyuoeyiij" />
        <Benefits data-id="element-747" data-mp="2vyq4vs72fs2h" />
        <SalderingBand data-id="element-748" data-mp="2vyhty5ui6wtx" />
        <ScanTeaser data-id="element-749" data-mp="2vvvpif2wsxfx" />
        <AppSection data-id="element-750" data-mp="2qyc14mchz4a9" />
        <ProductExplorer data-id="element-751" data-mp="2qxke3zwyuevl" />
        <ProcessTimeline data-id="element-752" data-mp="2qwsgkjjt672o" />
        <Reviews data-id="element-753" data-mp="2r0g8je9lulfa" />
        <Faq data-id="element-754" data-mp="2mxa5efhshad1" />
        <FinalCta data-id="element-755" data-mp="2mxrzp6kw5eib" />
      </main>
      <Footer data-id="element-756" data-mp="2mwgvx6rg46r7" />
    </div>;
}